module.exports = __webpack_public_path__ + "img/202408_04.a98e1d27.jpg";